export enum QuickFilterEnum {
  CREATED_ISSUES = 'created-issues',
  INCOMING_ISSUES = 'incoming-issues',
  MANAGED_ISSUES = 'managed-issues',
  OWNED_ISSUES = 'owned-issues',
  OWNED_ACTIONS = 'owned-actions',
  TO_BE_APPROVED = 'to-be-approved',
}

export enum CreatedIssuesTypeEnum {
  ALL = 'all',
  OPEN = 'open',
  IN_PROGRESS = 'in-progress',
}

export enum ManagedIssuesTypeEnum {
  ALL = 'all',
  ACTIONS_NOT_INITIATED = 'actions-not-initiated',
  ACTIONS_INITIATED = 'actions-initiated',
  ONGOING = 'ongoing',
  OVERDUE = 'overdue',
  SLA_OVERDUE = 'sla-overdue',
}

export enum IncomingIssuesTypeEnum {
  ALL = 'all',
  UNASSIGNED = 'unassigned',
}

export enum OwnedIssuesTypeEnum {
  ALL = 'all',
  ACTIONS_NOT_INITIATED = 'actions-not-initiated',
  ACTIONS_INITIATED = 'actions-initiated',
  ONGOING = 'ongoing',
  OVERDUE = 'overdue',
  TO_BE_APPROVED = 'to-be-approved',
}

export enum OwnedActionsTypeEnum {
  ALL = 'all',
  OPEN = 'open',
  IN_PROGRESS = 'in-progress',
  OVERDUE = 'overdue',
  TO_BE_APPROVED = 'to-be-approved',
  COMPLETED = 'completed',
}

export enum ToBeApprovedTypeEnum {
  ISSUES_TO_APPROVE = 'issues-to-approve',
  ACTIONS_TO_APPROVE = 'actions-to-approve',
}
